<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
};
</script>

<style>
html, body, #app {
  min-height: 100%;
  margin: 0;
  padding: 0;
}
</style>
